import { render, staticRenderFns } from "./LikeDislikePollModal.vue?vue&type=template&id=2ce68195"
import script from "./LikeDislikePollModal.vue?vue&type=script&lang=ts"
export * from "./LikeDislikePollModal.vue?vue&type=script&lang=ts"
import style0 from "./LikeDislikePollModal.vue?vue&type=style&index=0&id=2ce68195&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports